/**************************************************************************************************/
/*   File: /src/app/stores/actions/editing/editing.actions.ts                                     */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 29th 2019                                                         */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';

import * as fromShared from '../../../shared';

/**
 * The dossier editing action types enum
 */
export enum DossierEditingActionsType {

    CHECK_DOSSIER_STATUS = '[Editing] Check dossier status',
    CHECK_DOSSIER_STATUS_SUCCESS = '[Editing] Check dossier status success',
    CHECK_DOSSIER_STATUS_FAIL = '[Editing] Check dossier status fail',

    LOAD_DOSSIER = '[Editing] Load dossier',
    LOAD_DOSSIER_SUCCESS = '[Editing] Load dossier success',
    LOAD_DOSSIER_FAIL = '[Editing] Load dossier fail',

    VALIDATE_DOSSIER = '[Editing] Validate dossier',
    VALIDATE_DOSSIER_SUCCESS = '[Editing] Validate dossier success',
    VALIDATE_DOSSIER_FAIL = '[Editing] Validate dossier fail',

    SEND_DOSSIER = '[Editing] Send dossier',
    SEND_DOSSIER_SUCCESS = '[Editing] Send dossier success',
    SEND_DOSSIER_FAIL = '[Editing] Send dossier fail',

    DELETE_DOSSIER = '[Editing] Delete dossier',
    DELETE_DOSSIER_SUCCESS = '[Editing] Delete dossier success',
    DELETE_DOSSIER_FAIL = '[Editing] Delete dossier fail',

    UPDATE_SPATIAL_DATA_DOSSIER = '[Editing] Update spatial data dossier',
    UPDATE_SPATIAL_DATA_DOSSIER_SUCCESS = '[Editing] Update spatial data dossier success',
    UPDATE_SPATIAL_DATA_DOSSIER_FAIL = '[Editing] Update spatial data dossier fail',

    UPDATE_OTHER_DATA_DOSSIER = '[Editing] Update other data dossier',
    UPDATE_OTHER_DATA_DOSSIER_SUCCESS = '[Editing] Update other data dossier success',
    UPDATE_OTHER_DATA_DOSSIER_FAIL = '[Editing] Update other data dossier fail',

    UPDATE_REGULATION_DATA_DOSSIER = '[Editing] Update regulation data dossier',
    UPDATE_REGULATION_DATA_DOSSIER_SUCCESS = '[Editing] Update regulation data dossier success',
    UPDATE_REGULATION_DATA_DOSSIER_FAIL = '[Editing] Update regulation data dossier fail'
}

/**
 * Check dossier status
 */
export class CheckDossierStatus implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.CHECK_DOSSIER_STATUS;

    /**
     * The constructor
     * @param payload containing dossier status
     */
    constructor(public payload: { dossierId: fromShared.models.DossierId }) {
    }
}
/**
 * Check dossier status success
 */
export class CheckDossierStatusSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.CHECK_DOSSIER_STATUS_SUCCESS;

    /**
     * The constructor 
     * @param payload containing the status
     */
    constructor(public payload: { status: fromShared.models.DossierStatus }) {
    }
}
/**
 * Check dossier status fail
 */
export class CheckDossierStatusFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.CHECK_DOSSIER_STATUS_FAIL;

    /**
     * The constructor
     * @param payload containing message
     */
    constructor(public payload: { message: fromShared.models.Message }) {
    }
}
/**
 * Load dossier 
 */
export class LoadDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.LOAD_DOSSIER;

    /**
     * The constructor
     * @param payload containing dossier id
     */
    constructor(public payload: { dossierId: fromShared.models.DossierId }) {
    }
}
/**
 * Load dossier success
 */
export class LoadDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.LOAD_DOSSIER_SUCCESS;

    /**
     * The constructor 
     * @param payload containing the dossier
     */
    constructor(public payload: { dossier: fromShared.models.Dossier }) {
    }
}
/**
 * Load dossier fail
 */
export class LoadDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.LOAD_DOSSIER_FAIL;

    /**
     * The constructor
     * @param payload containing message
     */
    constructor(public payload: { message: fromShared.models.Message }) {
    }
}
/**
 * The validate dossier request
 */
export class ValidateDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.VALIDATE_DOSSIER;
    /**
     * The constructor 
     * @param payload The payload containing the dossier id
     */
    constructor(public payload: { dossierId: fromShared.models.DossierId }) { }
}
/**
 * The validate dossier success action
 */
export class ValidateDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.VALIDATE_DOSSIER_SUCCESS;
    /**
     * The constructor
     * @param payload The payload containing the result
     */
    constructor(public payload: { dossierId: fromShared.models.DossierId }) { }
}
/**
 * The validate dossier fail action
 */
export class ValidateDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.VALIDATE_DOSSIER_FAIL;
    /**
     * The constructor
     * @param payload containing message
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The delete dossier action
 */
export class DeleteDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.DELETE_DOSSIER;

    /**
     * The constructor
     * @param payload The payload containing the dossier id
     */
    constructor(public payload: { dossierId: fromShared.models.DossierId }) { }
}
/**
 * The delete dossier success action
 */
export class DeleteDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.DELETE_DOSSIER_SUCCESS;
    /**
     * The constructor
     * @param payload The payload containing the result
     */
    constructor(public payload: { result: fromShared.models.Result }) { }
}
/**
 * The delete dossier fail action 
 */
export class DeleteDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.DELETE_DOSSIER_FAIL;
    /**
     * The constructor
     * @param payload containing message
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}

/**
 * The send dossier action
 */
export class SendDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.SEND_DOSSIER;
    /**
     * The constructor
     * @param payload The payload containing the change status
     */
    constructor(public payload: { changeStatus: fromShared.models.DossierChangeStatus}) { }
}
/**
 * The send dossier success action
 */
export class SendDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.SEND_DOSSIER_SUCCESS;
    /**
     * The constructor
     */
    constructor() { }
}
/**
 * The send dossier fail
 */
export class SendDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.SEND_DOSSIER_FAIL;
    /**
     * The constructor
     * @param payload containing message
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The Update spatial data dossier 
 */
export class UpdateSpatialDataDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_SPATIAL_DATA_DOSSIER;
    /**
     * The constructor
     * @param payload The payload containing the dossierId, spatial data type, spatial data id
     */
    constructor(public payload: { dossierId: number, spatialDataType: fromShared.enums.SpatialDataTypeEnum, spatialDataId: string }) { }
}
/**
 * The Update spatial data dossier success
 */
export class UpdateSpatialDataDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_SPATIAL_DATA_DOSSIER_SUCCESS;
    /**
     * The constructor
     */
    constructor() { }
}
/**
 * The Update spatial data dossier  fail
 */
export class UpdateSpatialDataDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_SPATIAL_DATA_DOSSIER_FAIL;
    /**
     * The constructor
     * @param payload The payload containing the 
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The Update other data dossier 
 */
export class UpdateOtherDataDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_OTHER_DATA_DOSSIER;
    /**
     * The constructor
     * @param payload The payload containing the dossierId, other data id
     */
    constructor(public payload: { dossierId: number, otherDataId: string }) { }
}
/**
 * The Update other data dossier success
 */
export class UpdateOtherDataDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_OTHER_DATA_DOSSIER_SUCCESS;
    /**
     * The constructor
     */
    constructor() { }
}
/**
 * The Update other data dossier  fail
 */
export class UpdateOtherDataDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_OTHER_DATA_DOSSIER_FAIL;
    /**
     * The constructor
     * @param payload The payload containing the 
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The Update regulation data dossier 
 */
export class UpdateRegulationDataDossier implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_REGULATION_DATA_DOSSIER;
    /**
     * The constructor
     * @param payload The payload containing the dossierId, other data id
     */
    constructor(public payload: { 
        dossierId: number, 
        territorialAreaCode: string, 
        originalDoc: fromShared.models.LocalDocumentId, 
        deltaDoc: fromShared.models.LocalDocumentId,
        finalDoc: fromShared.models.LocalDocumentId 
    }) { }
}
/**
 * The Update regulation data dossier success
 */
export class UpdateRegulationDataDossierSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_REGULATION_DATA_DOSSIER_SUCCESS;
    /**
     * The constructor
     */
    constructor() { }
}
/**
 * The Update regulation data dossier  fail
 */
export class UpdateRegulationDataDossierFail implements Action {
    /**
     * The type
     */
    readonly type = DossierEditingActionsType.UPDATE_REGULATION_DATA_DOSSIER_FAIL;
    /**
     * The constructor
     * @param payload The payload containing the 
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The dossier actions type
 */
export type DossierEditingActions =
    CheckDossierStatus |
    CheckDossierStatusSuccess |
    CheckDossierStatusFail |
    LoadDossier |
    LoadDossierSuccess |
    LoadDossierFail |
    ValidateDossier |
    ValidateDossierSuccess |
    ValidateDossierFail |
    DeleteDossier |
    DeleteDossierSuccess |
    DeleteDossierFail |
    SendDossier |
    SendDossierSuccess |
    SendDossierFail |
    UpdateSpatialDataDossier |
    UpdateSpatialDataDossierSuccess |
    UpdateSpatialDataDossierFail |
    UpdateOtherDataDossier |
    UpdateOtherDataDossierSuccess |
    UpdateOtherDataDossierFail;
